import olView from 'ol/View';
import olControlOverviewMap from 'ol/control/OverviewMap';
import olLayerTile from 'ol/layer/Tile';
import olLayerImage from 'ol/layer/Image';
import olLayerVector from 'ol/layer/Vector';
import olLayerVectorTile from 'ol/layer/VectorTile';
import React from 'react';
import ReactDOM from 'react-dom';
import { MapModuleButton } from '../../MapModuleButton';
import { getNavigationTheme } from 'oskari-ui/theme';

/**
 * @class Oskari.mapframework.bundle.mapmodule.plugin.IndexMapPlugin
 *
 * Provides indexmap functionality for map. Uses image from plugin resources as the index map.
 *
 */
Oskari.clazz.define('Oskari.mapframework.bundle.mapmodule.plugin.IndexMapPlugin',
/**
 * @static @method create called automatically on construction
 *
 * @param {Object} config
 *      JSON config with params needed to run the plugin
 *
 */
function (config) {
  var me = this;
  me._clazz = 'Oskari.mapframework.bundle.mapmodule.plugin.IndexMapPlugin';
  me._defaultLocation = 'bottom right';
  me._index = 5;
  me._name = 'IndexMapPlugin';
  me._indexMap = null;
  me._baseLayerId = null;
}, {
  _startPluginImpl: function _startPluginImpl() {
    this._element = this._createControlElement();
    this.refresh();
    this.addToPluginContainer(this._element);
  },
  _stopPluginImpl: function _stopPluginImpl() {
    this._removeIndexMap();
    this.teardownUI();
  },
  /**
   * @private @method _createControlElement
   * Constructs/initializes the indexmap  control for the map.
   *
   *
   * @return {jQuery} element
   */
  _createControlElement: function _createControlElement() {
    /* overview map */
    var conf = this.getConfig() || {};
    var el;
    if (conf.containerId) {
      el = jQuery('#' + conf.containerId);
    } else {
      el = jQuery('<div class="mapplugin indexmap"></div>');
    }
    return el;
  },
  /**
   * @method _getOverviewLayers
   * Creates copy of base layer with same source.
   *
   * @return {Array<ol/layer/Layer>} returns empty array if no layers available
   */
  _getOverviewLayers: function _getOverviewLayers() {
    var result = [];
    var mapmodule = this.getMapModule();
    var layer = mapmodule.getBaseLayer();
    if (!layer) return result;
    var layerId = layer.getId();
    var olLayer = mapmodule.getOLMapLayers(layerId);
    if (!Array.isArray(olLayer)) return result;
    olLayer.forEach(function (l) {
      var source = l.getSource();
      if (l instanceof olLayerTile) {
        result.push(new olLayerTile({
          source: source
        }));
      } else if (l instanceof olLayerImage) {
        result.push(new olLayerImage({
          source: source
        }));
      } else if (l instanceof olLayerVector) {
        result.push(new olLayerVector({
          source: source,
          style: l.getStyle()
        }));
      } else if (l instanceof olLayerVectorTile) {
        result.push(new olLayerVectorTile({
          source: source,
          style: l.getStyle()
        }));
      }
    });
    this._baseLayerId = layerId;
    return result;
  },
  _createIndexMap: function _createIndexMap() {
    var collapsed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (this._indexMap) return;
    var el = this.getElement();
    if (!el) return;
    var indElement = jQuery('<div class="mapplugin ol_indexmap"></div>');
    var location = this.getLocation();
    if (location.includes('top')) {
      el.append(indElement);
    } else {
      el.prepend(indElement);
    }
    var olMap = this.getMap();
    var projection = olMap.getView().getProjection();
    this._indexMap = new olControlOverviewMap({
      target: indElement[0],
      layers: this._getOverviewLayers(),
      collapsed: collapsed,
      view: new olView({
        projection: projection
      })
    });
    olMap.addControl(this._indexMap);
  },
  _removeIndexMap: function _removeIndexMap() {
    if (!this._indexMap) return;
    this.getMap().removeControl(this._indexMap);
    var el = this.getElement();
    el.find('.ol_indexmap').remove();
    this._baseLayerId = null;
    this._indexMap = null;
  },
  _handleClick: function _handleClick() {
    if (!this._indexMap) {
      this._createIndexMap(false);
    } else {
      this._removeIndexMap();
    }
  },
  refresh: function refresh() {
    var _this = this;
    var el = this.getElement();
    if (!el) {
      return;
    }
    var theme = this.getMapModule().getMapTheme();
    var helper = getNavigationTheme(theme);
    var isDark = Oskari.util.isDarkColor(helper.getPrimary());
    // the icon is switched based on styleName -> passed to classes -> see scss
    var styleName = 'bg-dark';
    if (!isDark) {
      styleName = 'bg-light';
    }
    ReactDOM.render(/*#__PURE__*/React.createElement("div", {
      className: "indexmapToggle ".concat(styleName)
    }, /*#__PURE__*/React.createElement(MapModuleButton, {
      className: "t_indexmap",
      onClick: function onClick() {
        return _this._handleClick();
      },
      size: "48px",
      icon: /*#__PURE__*/React.createElement("div", {
        className: "icon"
      })
    })), el[0]);
  },
  resetUI: function resetUI() {
    if (this._indexMap) {
      this._removeIndexMap();
    }
  }
}, {
  extend: ['Oskari.mapping.mapmodule.plugin.BasicMapModulePlugin'],
  /**
   * @static @property {string[]} protocol array of superclasses
   */
  protocol: ['Oskari.mapframework.module.Module', 'Oskari.mapframework.ui.module.common.mapmodule.Plugin']
});